import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Gender } from '../../../api/app-types/gender.app';
import { GENDER_API } from '../../../api/injection-tokens/services.token';

export const genderResolver: ResolveFn<Gender[]> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(GENDER_API);
	const response = await api.getAll();
	return response;
};
